import { permissionTypes } from "hooks/usePermissions";

const { ENTERPRISE_ADMIN } = permissionTypes;

const commonTabs = [
  {
    key: "seated",
    label: "Seated Organization",
  },
  {
    key: "users",
    label: "All Organization Sellers",
  },
  {
    key: "invites",
    label: "Invites",
  },
];

const adminTabs = [
  {
    key: "seat-approvals",
    label: "Seat Approvals",
    permission: ENTERPRISE_ADMIN,
  },
];

export { commonTabs, adminTabs };
export default [...commonTabs, ...adminTabs];
